import type {FirstTransferEvents} from "core/transfer/firstTransferEvents";
import {reportFirstTransferSent} from "./conversions";

/**
 * The one subscriber that turns the send paths' firstness answers into the `FIRST_TRANSFER_SENT` browser event
 * (kitecorp/transferify-ui#3419). The send paths only name what the api answered (`core/transfer/firstTransferEvents`);
 * whether and how that is reported is decided here and in {@link reportFirstTransferSent}, so no send path imports
 * analytics (owner's 2026-08-27 rule).
 *
 * This is the GA4 event only. The ad networks' first-transfer conversion is recorded by the api when it claims the
 * account's first transfer, whichever path sent it.
 *
 * @returns the unsubscribe
 */
export function wireFirstTransferTelemetry(events: Pick<FirstTransferEvents, "subscribe">): () => void {
	return events.subscribe(answer => reportFirstTransferSent(answer.wasFirst, answer.path));
}
